/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { DesignWell } from "./DesignWell";
import {
  DesignWellFromJSON,
  DesignWellFromJSONTyped,
  DesignWellToJSON,
  DesignWellToJSONTyped,
} from "./DesignWell";

/**
 *
 * @export
 * @interface ApiGufWellsList200Response
 */
export interface ApiGufWellsList200Response {
  /**
   *
   * @type {number}
   * @memberof ApiGufWellsList200Response
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof ApiGufWellsList200Response
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiGufWellsList200Response
   */
  previous?: string | null;
  /**
   *
   * @type {Array<DesignWell>}
   * @memberof ApiGufWellsList200Response
   */
  results: Array<DesignWell>;
}

/**
 * Check if a given object implements the ApiGufWellsList200Response interface.
 */
export function instanceOfApiGufWellsList200Response(
  value: object
): value is ApiGufWellsList200Response {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function ApiGufWellsList200ResponseFromJSON(json: any): ApiGufWellsList200Response {
  return ApiGufWellsList200ResponseFromJSONTyped(json, false);
}

export function ApiGufWellsList200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApiGufWellsList200Response {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(DesignWellFromJSON),
  };
}

export function ApiGufWellsList200ResponseToJSON(json: any): ApiGufWellsList200Response {
  return ApiGufWellsList200ResponseToJSONTyped(json, false);
}

export function ApiGufWellsList200ResponseToJSONTyped(
  value?: ApiGufWellsList200Response | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(DesignWellToJSON),
  };
}
